import { getBaseUrlFromPiva, nsApi } from 'boot/axios'
import { MyStorage } from 'src/logic'

class InvalidTenant extends Error {
  constructor() {
    super()

    // // Maintains proper stack trace for where our error was thrown (only available on V8)
    // if (Error.captureStackTrace) {
    //   Error.captureStackTrace(this, InvalidTenant)
    // }

    this.name = 'InvalidTenant'
  }
}

/**
 * Desktop remoto (rdp.ilpas.it): link all'app se attiva per il tenant e per l'utente
 * (licenza attiva e account configurato dall'HUB), altrimenti mail all'assistenza per
 * chiedere informazioni. Non c'è per chi ha GO (`as`): i due si escludono.
 */
function rdpApplication(apps, piva, user) {
  if (apps.includes('as')) return []
  const active = apps.includes('rdp') && !!user && !!user.rdp_active && !!user.rdp_username
  const body = `Buongiorno,\n\nvorrei ricevere informazioni sul servizio Desktop remoto IlPas.\n\nP.IVA: ${piva || ''}\n\nGrazie`
  return [{
    value: 'rdp',
    label: 'RDP',
    icon: 'mdi-remote-desktop',
    caption: active ? 'Il tuo desktop di lavoro, dal browser' : 'Richiedi informazioni',
    badge: 'Beta',
    href: active
      ? `https://rdp.${process.env.DOMAIN}`
      : `mailto:assistenza@ilpas.it?subject=${encodeURIComponent('Richiesta informazioni Desktop remoto')}&body=${encodeURIComponent(body)}`,
  }]
}

export default {
  namespaced: true,

  state: {
    piva: null,
    baseURL: null,
    locale: null,
    apps: [],
  },

  getters: {
    url: ({ baseURL }) => {
      if (baseURL) return `https://${baseURL}.${process.env.URI}.${process.env.DOMAIN}/api`
      throw new InvalidTenant()
    },
    applications: (state, _, rootState) => [
      ...[
        { value: 'as', label: `${rootState.theme.theme} GO`, icon: 'mdi-monitor-dashboard', disable: rootState.auth.user.Sospeso !== null ? rootState.auth.user.Sospeso : true },
        { value: 'calendar', label: 'Calendar', icon: 'mdi-calendar-blank', caption: 'Agenda di tutti i collaboratori' },
        { value: 'mentore', label: 'Mentore', icon: 'mdi-face-agent', caption: 'Consigliere saggio e fidato', disable: !rootState.auth.user.crm_accesso },
        { value: 'myapp', label: 'MyApp Studio', icon: 'mdi-application' },
        { value: 'minosse', label: 'Minosse', icon: 'mdi-ear-hearing', caption: 'Sincronizzazione con Noah' },
        { value: 'ai', label: 'AI', icon: 'mdi-auto-fix', caption: 'Parla con i tuoi dati', badge: 'Beta' },
      ].filter(a => state.apps.includes(a.value)),
      ...rdpApplication(state.apps, state.piva, rootState.auth.user),
    ],
  },

  actions: {
    async setApplications({ commit }, piva) {
      const { data: { applications, theme, locale } } = await nsApi.post('check-active', { piva, app: process.env.URI })
      commit('SET_APPS', applications.map(a => a.app))
      commit('theme/update', theme, { root: true })
      commit('SET_KEY', { key: 'locale', value: locale })
    },

    async init({ commit, state }) {
      MyStorage.has('piva') && commit('SET_KEY', { key: 'piva', value: MyStorage.get('piva') })
      MyStorage.has('baseURL') && commit('SET_KEY', { key: 'baseURL', value: MyStorage.get('baseURL') })
      // MyStorage.has('locale') && commit('SET_KEY', { key: 'locale', value: MyStorage.get('locale') })

      state.piva && !state.baseURL && commit('SET_KEY', { key: 'baseURL', value: await getBaseUrlFromPiva(state.piva) })
    },

    async setKeys({ commit }, { piva, baseURL, locale }) {
      piva !== undefined && commit('SET_KEY', { key: 'piva', value: piva })
      baseURL !== undefined && commit('SET_KEY', { key: 'baseURL', value: baseURL })
      locale !== undefined && commit('SET_KEY', { key: 'locale', value: locale })
    },
  },

  mutations: {
    SET_APPS(state, apps) { state.apps = apps },
    SET_KEY(state, { key, value }) {
      state[key] = value
      value === null
        ? MyStorage.remove(key)
        : MyStorage.set(key, value)
    },
  },
}
